/**
 *
 * IBM Confidential
 *
 * (C) Copyright IBM Corp. 2021, 2022
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U. S. Copyright Office
 *
 * US Government Users Restricted Rights - Use, duplication or
 * disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 *
 **/

import axios from 'axios';

import { Account } from '../../../../ts/account';
import { Instances } from '../../../../ts/instance';
import { endpoints } from '../../util/config';
import { mapInstance } from './helper';

export const listInstances = async (options?: {
  export: boolean;
}): Promise<Instances> => {
  const response = await axios.get(endpoints.bluemix + '/instances', {
    params: {
      export: Boolean(options?.export)
    }
  });
  return {
    resources: response.data.resources.map(mapInstance),
    inaccessibleAccountNames: Array.isArray(response.data.inaccessible_accounts)
      ? response.data.inaccessible_accounts.map(
          (account: Account) => account.name
        )
      : []
  };
};
